import React from "react";
import { useFamaFlags } from "../api/FamaFlags";
import { usePersonRegion } from "../api/PersonApi";
import { classNames } from "../utils";

export const EU_BADGE_TOOLTIP = "Personal data stored in the EU region";

type Props = {
  personUuid: string | undefined;
  className?: string;
};

/** Renders nothing unless the flag is on and the person registry says EU. */
function EuRegionBadge({ personUuid, className }: Props) {
  const { v3EuBadgeEnabled } = useFamaFlags();
  const { data } = usePersonRegion(personUuid, v3EuBadgeEnabled);

  if (!v3EuBadgeEnabled || data?.region !== "EU") return null;

  return (
    <span
      title={EU_BADGE_TOOLTIP}
      data-testid="eu-region-badge"
      className={classNames(
        "inline-flex items-center flex-shrink-0 align-middle",
        "rounded-full border border-sky-200 bg-sky-100 px-2 py-0.5",
        "text-xs font-semibold leading-4 tracking-wide text-sky-700",
        className
      )}
    >
      EU
    </span>
  );
}

export default EuRegionBadge;
